// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yiHS","index":"styles_index__2c0Aw"};